import React, { useState } from 'react';
import { ImageList, ImageListItem } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import CommonLoader from '../../../../components/common-loader/CommonLoader';
import ContentCard from '../../../../activ8/find/content-list/card/ContentCard';
import CommonPagination from '../../../../components/common-pagination/CommonPagination';
import ContentModal from '../../../../activ8/find/content-modal/ContentModal';
import EmptySearchResults from './empty-search-results/EmptySearchResults';
import useGridElementsCount from '../../../../activ8/hooks/useGridElementsCount';
import { changeTableSettings } from '../../../../redux/settings/activ8/activ8SettingsReducer';
import { restoreActiv8Content } from '../../../../redux/settings/activ8/activ8SettingsActions';
import { selectActiv8ArchiveBucketById } from '../../../../redux/settings/activ8/activ8SettingsSelectors';

import scss from '../../../../activ8/find/content-list/ContentList.module.scss';

function ArchiveContentList() {
  const dispatch = useDispatch();

  const [previewData, setPreviewData] = useState({});
  const content = useSelector((state) => state.activ8Settings.content);
  const isLoading = useSelector((state) => state.activ8Settings.isLoading);
  const { page, size, totalElements } = useSelector((state) => state.activ8Settings.tableSettings);

  const colsCount = useGridElementsCount();

  const handleChangePage = (newPage) => {
    dispatch(changeTableSettings({ page: newPage }));
  };

  const handlePreview = ({ bucketId, initialIndex }) => {
    setPreviewData({ bucketId, initialIndex });
  };

  const closePreview = () => {
    setPreviewData({});
  };

  const handleRestore = (slide) => {
    if (!slide?.id) {
      return;
    }

    dispatch(restoreActiv8Content({ contentId: slide.id }));
  };

  return (
    <div className={scss.wrapper}>
      {!content.length && !isLoading ? <EmptySearchResults /> : null}

      {content.length ? (
        <>
          <ImageList variant='masonry' cols={colsCount} gap={8}>
            {content.map((item) => (
              <ImageListItem key={item.bucketId}>
                <ContentCard
                  media={item.media}
                  bucketId={item.bucketId}
                  onPreview={handlePreview}
                  onRestore={handleRestore}
                  enableTagFilter={false}
                />
              </ImageListItem>
            ))}
          </ImageList>

          <div className={scss.paginationWrapper}>
            <CommonPagination
              totalItemsCount={totalElements}
              itemsPerPage={size}
              activePage={page}
              onChangePage={handleChangePage}
            />
          </div>
        </>
      ) : null}

      <CommonLoader isLoading={isLoading} />

      <ContentModal
        isOpen={!!previewData?.bucketId}
        onClose={closePreview}
        initialIndex={previewData?.initialIndex}
        bucketId={previewData?.bucketId}
        onRestore={handleRestore}
        selectBucketById={selectActiv8ArchiveBucketById}
      />
    </div>
  );
}

export default ArchiveContentList;
